/** Internal dependencies */
import { apiCall } from './apiCall';
import { getCurrentFilters } from './getCurrentFilters';

export function handleLoadMore(e) {
    e.preventDefault();

    const parent = e.target.closest('[data-rest]');

    if (!parent) {
        return;
    }

    const api = JSON.parse(parent.dataset.rest);
    let apiFilter = '';

    // update pagination
    const offset = parent.querySelector('.offset-posts');
    if (offset) {
        offset.value = parseInt(offset.value) + 6;
        apiFilter = getCurrentFilters(parent);
    }

    api.currentpage++;
    parent.dataset.rest = JSON.stringify(api);

    apiCall(parent, apiFilter, false, true);
}
